export default {
  /**
   * base64をBlog形式に変換する
   * @param {*} base64
   * @returns
   */
  toBlob: function (base64) {
    let bin = atob(base64.replace(/^.*,/, ''));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    // Blobを作成
    let blob;
    try {
      blob = new Blob([buffer.buffer], { type: 'image/jpg' });
    } catch (e) {
      return false;
    }
    return blob;
  },
  /**
   * base64をBlog形式に変換する
   * @param {*} base64
   * @returns
   */
  toBlob2: function (base64) {
    let bin = atob(base64.replace(/^.*,/, ''));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    // Blobを作成
    let blob;
    try {
      blob = new Blob([buffer.buffer]);
    } catch (e) {
      return false;
    }
    return blob;
  },
  /**
   * 文字列をスネークケースからキャメルケースに変換する
   * @param {*} str 変換対象の文字列
   * @returns キャメルケースに変換した文字列
   */
  toCamelCase: function (str) {
    return str
      .split('_')
      .map(function (word, index) {
        if (index === 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
  },
  /**
   * オブジェクトをスネークケースからキャメルケースに変換する
   * @param {*} obj 変換対象のオブジェクト
   * @returns キャメルケースに変換したオブジェクト
   */
  toCamelCaseForObject: function (obj) {
    const result = {};
    Object.keys(obj).forEach((key) => {
      result[this.toCamelCase(key)] = obj[key];
    });
    return result;
  },
  /**
   * 未入力文字列に変換する（文字列用）
   * @param {*} value
   */
  toConfirmationLabelForDate: function (year, month, day) {
    if (!year || !month || !day) return '(未入力)';
    // if (year === '' || month === '' || day === '') return '(未入力)';
    return `${year}年${month}月${day}日`;
  },
  /**
   * 未入力文字列に変換する（文字列用）
   * @param {*} value
   */
  toConfirmationLabelForString: function (value) {
    return value ? value : '(未入力)';
  },
  /**
   * 日付/時刻を文字列に変換する
   * @param {*} date 日付/時刻
   * @param {*} format フォーマット
   * @returns 日付/時刻文字列
   */
  toDateString: function (date, format) {
    format = format.replace(/yyyy/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
    return format;
  },
  /**
   * 日本円表記に変換する
   * @param {*} price
   * @param {*} defaultChar
   * @returns
   */
  toJpy: function (price, defaultChar) {
    if (!price && price !== 0) return defaultChar ? defaultChar : '';
    const s = String(price).split('.');
    let ret = String(s[0]).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    if (s.length > 1) {
      ret += '.' + s[1];
    }
    return `¥${ret}`;
  },
  /**
   * 文字列をキャメルケースからスネークケースに変換する
   * @param {*} str 変換対象の文字列
   * @returns スネークケースに変換した文字列
   */
  toSnakeCase: function (str) {
    return str
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase();
  },
  /**
   * オブジェクトをキャメルケースからスネークケースに変換する
   * @param {*} obj 変換対象のオブジェクト
   * @returns スネークケースに変換したオブジェクト
   */
  toSnakeCaseForObject: function (obj) {
    const result = {};
    Object.keys(obj).forEach((key) => {
      result[this.toSnakeCase(key)] = obj[key];
    });
    return result;
  },
};
